import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IUserRole } from '../types/IUserRole';

export interface IGetUsersSiteRolesParams {
  ids: string[];
}

export interface IGetUsersSiteRolesResult extends IResult {
  users: IUserRole[];
}

export class GetUsersSiteRolesRequest extends Request<IGetUsersSiteRolesParams, IGetUsersSiteRolesResult> {
  constructor(params: IGetUsersSiteRolesParams) {
      super('getUsersSiteRoles', params);
  }
}
